import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const KEY = "ciftora_install_hint_until";
const HIDE_DAYS = 30;

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export const InstallPrompt = () => {
  const [visible, setVisible] = useState(false);
  const [deferred, setDeferred] = useState(null);
  const ios = isIOS();

  useEffect(() => {
    if (isStandalone()) return;
    const until = Number(localStorage.getItem(KEY) || 0);
    if (until > Date.now()) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    // iOS'ta beforeinstallprompt yok; Safari'de elle yönlendirme gösterilir.
    const t = ios ? setTimeout(() => setVisible(true), 2500) : null;
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      if (t) clearTimeout(t);
    };
  }, [ios]);

  const dismiss = () => {
    localStorage.setItem(KEY, String(Date.now() + HIDE_DAYS * 86400000));
    setVisible(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setVisible(false);
    else dismiss();
    setDeferred(null);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      style={{ zIndex: 46, bottom: "calc(var(--mobile-bottom-nav-height, 60px) + env(safe-area-inset-bottom))" }}
      className="fixed left-3 right-3 flex items-center gap-3 rounded-xl border border-border bg-card p-3 shadow-lg md:left-auto md:right-6 md:max-w-sm"
    >
      <img
        src="/brand/ciftora/symbol/ciftora-app-icon-192.png"
        alt="Ciftora – Çiftliğin Dijital Dünyası"
        className="h-10 w-10 rounded-lg"
      />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-primary">Ciftora'yı ana ekrana ekle</p>
        {ios && !deferred ? (
          <p className="mt-0.5 text-xs text-muted-foreground" data-testid="install-prompt-ios-hint">
            Safari'de <Share className="inline h-3 w-3" /> Paylaş → “Ana Ekrana Ekle”
          </p>
        ) : (
          <p className="mt-0.5 text-xs text-muted-foreground">Uygulama gibi tek dokunuşla açılsın</p>
        )}
      </div>
      {!ios || deferred ? (
        <button
          onClick={install}
          data-testid="install-prompt-install"
          className="flex h-10 shrink-0 items-center gap-1.5 rounded-full bg-primary px-4 text-xs font-bold text-primary-foreground"
        >
          <Download className="h-4 w-4" /> Ekle
        </button>
      ) : null}
      <button onClick={dismiss} data-testid="install-prompt-dismiss" aria-label="Kapat" className="shrink-0 p-1">
        <X className="h-4 w-4 text-muted-foreground" />
      </button>
    </div>
  );
};
